import { useData } from "../runtime/provider";
import { useCallback, useEffect } from "react";
import { router } from "expo-router";

import { USER_LISTUNLOCKEDPRIVATESONGS_QUERY_KEY } from "@hooks/trpc/useListUnlockedPrivateSongs";
import { getQueryKey } from "@trpc/react-query";
import { trpc } from "@utils/trpc";
import { accessTicketsQueryKey, useAccess } from "@hooks/trpc/useAccesses";

import { useNavigationStore } from "@utils/navigation/useNavigationStore";
import { libraryQueryKey } from "@hooks/trpc/useLibrary/queryFunctions";

export default function PaymentsCallbackHandler() {
  const session = useData();
  const paymentResult = useNavigationStore((state) => state.paymentResult);
  const accessId = useNavigationStore((state) => state.accessId);

  const { data: access, refetch } = useAccess(accessId);

  const clearParams = useCallback(() => {
    router.setParams({
      paymentResult: undefined,
    });
  }, []);

  useEffect(() => {
    if (paymentResult && accessId && access) {
      if (paymentResult === "success" && accessId) {
        // delay to ensure stripe webhook is called
        setTimeout(() => {
          // Invalidate library query to refresh UI with auto-liked album from backend
          if (access.type === "music") {
            session.queryClient
              .invalidateQueries({
                queryKey: libraryQueryKey(),
              })
              .catch((error) => {
                console.error("Error refetching library", error);
              });
          }

          session.queryClient
            .invalidateQueries({
              queryKey: USER_LISTUNLOCKEDPRIVATESONGS_QUERY_KEY,
              refetchType: "all",
            })
            .catch((error) => {
              console.error("Error refetching unlocked private songs", error);
            });

          session.utils.accesses.getMusicAccessByArtistId
            .invalidate({
              artistId: access.artistId,
            })
            .catch((error) => {
              console.error(error);
            });

          refetch().catch((error) => {
            console.error(error);
          });

          session.queryClient
            .invalidateQueries({
              queryKey: getQueryKey(trpc.accesses.getStoreByArtistId, {
                artistId: access.artistId,
              }),
            })
            .catch((error) => {
              console.error(error);
            });

          session.queryClient
            .invalidateQueries({
              queryKey: accessTicketsQueryKey(),
            })
            .catch((error) => {
              console.error(error);
            });
          clearParams();
        }, 500);
      } else if (paymentResult === "cancel" && accessId) {
        // On cancel, just clear the paymentResult param
        // Don't navigate away - let the user stay on the current page (checkout)
        // and use browser back button to go back to details if needed
        clearParams();
      }
    }
  }, [accessId, paymentResult, access, refetch]);

  return null;
}
